import { Assets, Container, Graphics, Renderer, Sprite, Spritesheet, Text, Texture } from 'pixi.js';

import { notNil } from 'app/utils/stream-util';

import { COLOR_WHITE, COLOR_NAVY } from '../constants';

export class IconButton extends Container {
  private _sprite: Sprite | undefined;
  private _icon: Text | undefined;
  private onTap: (() => void) | undefined;
  private svgPath: string | undefined;
  public ready = false;

  public constructor(
    {
      icon,
      onTap,
      svgPath,
      x,
      y,
    }: {
      icon: string;
      x: number;
      y: number;
      onTap: (() => void) | undefined;
      svgPath?: string;
    },
    sprites: Spritesheet,
  ) {
    super();
    this.x = x;
    this.y = y;
    this.onTap = onTap;
    this.svgPath = svgPath;

    void this.init(icon, sprites);
  }

  private async init(icon: string, sprites: Spritesheet): Promise<void> {
    const svgPathPresent = notNil(this.svgPath);
    const iconText = this.createButtonIcon(icon);
    const sprite = new Sprite(sprites.textures['hover-icon-background.svg']);

    this.name = `${icon}-button`;
    sprite.name = `${icon}-button-sprite`;
    this.addChild(sprite);

    if (svgPathPresent) {
      const svgTexture = await Assets.load(this.svgPath!);
      const svgSprite = Sprite.from(svgTexture);
      svgSprite.anchor.set(0.5, 0.5);
      svgSprite.position.set(0, 0);
      svgSprite.name = 'icon';
      this.addChild(svgSprite);
    }

    sprite.anchor.set(0.5, 0.5);
    this.visible = false;
    this.eventMode = 'static';
    this.cursor = 'pointer';

    this.on('pointertap', ($event) => {
      $event.stopPropagation();
      $event.preventDefault();
      this.onTap?.();
    });

    if (!svgPathPresent) {
      this.addChild(iconText);
    }

    this._sprite = sprite;
    this._icon = iconText;
    this.ready = true;
  }

  private createButtonIcon(icon: string): Text {
    const buttonIcon = new Text(icon, {
      fill: COLOR_NAVY,
      fontFamily: 'Material Icons',
      fontSize: 20,
      padding: 0,
      lineHeight: 20,
    });
    if (icon === 'textsms') {
      buttonIcon.anchor.set(0.5, 0.35);
    } else {
      buttonIcon.anchor.set(0.5, 0.4);
    }
    buttonIcon.resolution = 2;
    return buttonIcon;
  }

  public get sprite(): Sprite {
    if (!this._sprite) {
      throw new Error('Sprite not initialized');
    }
    return this._sprite;
  }
  public show(): void {
    this.visible = true;
  }

  public hide(): void {
    this.visible = false;
  }

  public set icon(name: string) {
    if (this._icon) {
      this._icon.text = name;
    }
  }

  public destroy(): void {
    this.off('pointertap');
    this._sprite?.destroy();
    this._icon?.destroy();
  }
}
